import { required } from "@corporate-tailwind/corp-form";
import { SelectImage } from "@corporate-tailwind/model";

export class CountryDto extends SelectImage {
    isHighRisk: boolean | null = null; 
}
